<div class="row">
  <div class="col">
    <h3>Nova ocorrência</h3>
  </div>

  <div class="col-auto">
    <button type="button" class="btn btn-danger no-margin" (click)="voltarParaPesquisa()">
      Cancelar
    </button>
  </div>

  <div class="col-auto">
    <button type="button" class="btn btn-primary no-margin" [disabled]="!cadastroForm.valid" (click)="enviar()">
      Salvar
    </button>
  </div>
</div>

<section class="container">
  <form [formGroup]="cadastroForm">

    <div class="row">

      <div class="bn-form-group col-md-3">
        <label class="form-label" for="tipoOperacao"><b>Tipo de operação: </b></label>
        <select id="tipoOperacao" class="form-select" formControlName="tipoOperacao" (change)="liberaOperacaoRepasse()">
          <option *ngFor="let tipoOperacao of tiposOperacao" [ngValue]="tipoOperacao.codigo">
            {{ tipoOperacao.label }}
          </option>
        </select>
      </div>

      <div class="bn-form-group col-md-5">
        <label class="form-label" for="idOperacaoCreditoLivre"><b>Id. operação crédito livre:</b></label>
        <input id="idOperacaoCreditoLivre" type="text" class="form-control" formControlName="idOperacaoCreditoLivre">
      </div>

      <div class="bn-form-group col-md-2">
        <label class="form-label" for="sistemaRepasse"><b>Sist. repasse:</b></label>
        <input id="sistemaRepasse" type="text" class="form-control" formControlName="sistemaRepasse">
      </div>

      <div class="bn-form-group col-md-2">
        <label class="form-label" for="contratoRepasse"><b>Contrato repasse:</b></label>
        <input id="contratoRepasse" type="text" class="form-control" formControlName="contratoRepasse">
      </div>

    </div>

    <div class="row">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="tipoTransacao"><b>Tipo da ocorrência:</b></label>
        <select id="tipoTransacao" class="form-select" formControlName="tipoTransacao" (change)="trocaIdOperacaoAgente()">
          <option value="I">Inclusão de IPOC</option>
          <option value="T">Troca de IPOC</option>
          <option value="A">Alteração de dados no SCR</option>
          <option value="O" [disabled]="desabilitaTrocaIdOperacaoAgente">Operação troca de ID do agente</option>
        </select>
      </div>

      <div class="bn-form-group col-md-6">
        <label class="form-label" for="novoIdOperacaoAgenteCreditoLivre"><b>Novo Id. operação agente crédito livre:</b></label>
        <input id="novoIdOperacaoAgenteCreditoLivre" type="text" class="form-control" formControlName="novoIdOperacaoAgenteCreditoLivre">
      </div>
    </div>

    <div class="row">
      <div *ngIf="agenteFinanceiroEhAssociado" class="bn-form-group col-md-6">
        <label class="form-label" for="tipoIpoc"><b>Tipo de IPOC:</b></label>
        <select id="tipoIpoc" class="form-select" formControlName="tipoIpoc">
          <option *ngFor="let opcao of listaTipoIpoc" [ngValue]="opcao.value">
            {{ opcao.label }}
          </option>
        </select>
      </div>

      <div class="bn-form-group col-md-6">
        <label class="form-label" for="ipoc"><b>IPOC novo/atual:</b></label>
        <input id="ipoc" type="text" class="form-control" formControlName="ipoc">
      </div>

      <div class="text-danger mt-1" *ngIf="cadastroForm.get('ipoc')?.touched && cadastroForm.get('ipoc')?.hasError('raizIpocNaoAssociada')">
        IPOC inválido: os 8 primeiros caracteres devem pertencer a um CNPJ de associado ou ser iguais à raiz do CNPJ do agente financeiro.
      </div>

      <div class="bn-form-group col-md-3">
        <label class="form-label" for="mesReferencia"><b>Mês de referência:</b></label>
        <input id="mesReferencia" type="text" class="form-control" bnMask="MESANO" formControlName="mesReferencia">
      </div>

      <div class="bn-form-group col-md-4">
        <label class="form-label" for="dataEnvio"><b>Data envio SCR/BC:</b></label>
        <bn-datepicker
          name="dataEnvio"
          formControlName="dataEnvio"
          ngDefaultControl>
        </bn-datepicker>
      </div>

    </div>

  </form>
</section>